module.exports = "<div class=\"loader-img-holder\"><img class=\"loader-img\" src=\"/images/loader.svg\"></div>";